<template>
  <v-sheet
    v-if="items.length"
    class="stores"
    :color="smAndDown ? `white` : `grey`"
  >
    <v-container>
      <v-row>
        <v-col cols="12" lg="7" class="pr-md-8 pb-14 pb-md-0">
          <Title v-if="!smAndDown">Nossas Lojas</Title>
          <div v-else class="pb-6">
            <Title doubleLine>Nossas Lojas</Title>
          </div>
          <v-row class="pt-6 pt-sm-10 pt-md-16">
            <v-col
              v-for="(item, i) in items"
              :key="i"
              cols="12"
              class="pl-md-0"
            >
              <StoresCard :item="item" />
              <div class="px-2 px-md-0">
                <v-sheet
                  v-if="i != lastItemIndex"
                  width="100%"
                  class="store-before-line mt-5 mb-md-5"
                  height="1px"
                ></v-sheet>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="5" class="pl-md-10 pa-0" id="fale-conosco">
          <v-sheet
            :color="smAndDown ? `#F7F7F7` : `white`"
            height="100%"
            class="
              py-12 py-lg-5
              px-md-5 px-2 px-lg-10
              d-flex
              align-center
              justify-center
            "
          >
            <ContactForm />
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import StoresCard from "../../cards/StoresCard.vue";
import { getWhatsappLinkFromPhone } from "../../../utils/getWhatsappLinkFromPhone";
import { getStoreWhatsappContacts } from "../../../utils/storeWhatsappContacts";
import ContactForm from "../../../widgets/ContactForm.vue";
import Title from "../../../widgets/Title.vue";
export default {
  data: () => ({
    items: [],
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    lastItemIndex() {
      return this.items.length - 1;
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.$rest(`stores`)
        .get()
        .then((data) => {
          this.items = data.map((store) => {
            const { title, img, address, maps, whatsapp } = store;
            const whatsappContacts = getStoreWhatsappContacts(store);

            return {
              title,
              address,
              maps,
              img: this.files + img,
              whatsapp,
              whatsappLink: whatsappContacts[0]?.whatsappLink,
              whatsappContacts,
            };
          });
        });
    },
    getWhatsappLinkFromPhone,
  },
  components: { StoresCard, ContactForm, Title },
};
</script>

<style lang="scss" scoped>
.stores {
  background-image: url(/img/pneu3.png);
  background-position: right bottom;
  background-size: 40%;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 1264px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media (max-width: 960px) {
    padding-top: 60px;
    padding-bottom: 0px;
    background: none;
  }
  @media (max-width: 600px) {
    padding-top: 40px;
  }

  .store-before-line {
    background-color: rgb(0, 0, 0, 0.1);
  }
}
</style>
